import { render } from "./ManageReceiverContent.vue?vue&type=template&id=48eceaec"
import script from "./ManageReceiverContent.vue?vue&type=script&lang=js"
export * from "./ManageReceiverContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__